import React, { ChangeEventHandler, FocusEventHandler, useMemo } from "react";

import { useFormData } from "@sp-state/useFormData";
import IconsWrapper from "../ProfessionsInput/IconsWrapper";
import InputWrapper from "../InputWrapper";

import styles from "../ProfessionsInput/ProfessionsInput.module.scss";
import { QuestionAttribute } from "@components/BuilderComponents/SignupFormDrip/sfd-components/Form/sfd-helpers/sfd-form.type";

type QuestionAttributes = {
  questionAttributes: QuestionAttribute | null;
};

const UniqueChoice = ({ questionAttributes }: QuestionAttributes) => {
  const { setQuestionError, setQuestionValid, setQuestions } = useFormData(
    state => state
  );

  const value = useMemo(
    () => questionAttributes?.value?.at(0) || "",
    [questionAttributes?.value]
  );

  const name = questionAttributes?.questionName || "";

  const onBlur: FocusEventHandler<HTMLSelectElement> = e => {
    if (e.target.value.trim() === "" && !questionAttributes?.questionOptional) {
      setQuestionError(name, true);
      setQuestionValid(name, false);
    }
  };

  const onChange: ChangeEventHandler<HTMLSelectElement> = e => {
    const { value } = e.target;

    setQuestions(name, [value]);

    if (questionAttributes?.hasError && !questionAttributes?.questionOptional) {
      setQuestionError(name, false);
    }

    if (value.trim() !== "") {
      setQuestionValid(name, true);
    }
  };

  const questionOptions = questionAttributes?.questionDropdownOptions?.map(
    option => (
      <option key={option.Dropdown} value={option.Dropdown}>
        {option.Dropdown}
      </option>
    )
  );

  return (
    <>
      <InputWrapper
        errorMsg="This field is required."
        hasError={questionAttributes?.hasError}
        optional={questionAttributes?.questionOptional}
        label={questionAttributes?.questionTitle || ""}
      >
        <div className={styles.selectField}>
          <select
            className={`${styles.field} ${
              questionAttributes?.hasError && styles.error
            }`}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            multiple={questionAttributes?.questionType === "multipleSelect"}
          >
            <option value="" disabled>
              Select one
            </option>
            {questionOptions}
          </select>
          <IconsWrapper
            hasError={questionAttributes?.hasError}
            isOther={false}
            isValid={questionAttributes?.isValid}
          />
        </div>
      </InputWrapper>
    </>
  );
};

export default UniqueChoice;
